<template>
    <v-dialog v-model="dialog" width="1200px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">{{ title }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-textarea v-model="faqs" rows="20"></v-textarea>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="closeDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                title: "",
                faqs: "",
            }
        },
        methods: { 
            openDialog(title, faqs) {
                this.title = title;
                this.faqs = faqs;
                this.dialog = true;
            },
            closeDialog() {
                this.dialog = false;
            },
        }
    }
</script>